export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getContactUsContent() {
            return new Promise((resolve, reject) => {
                window.axios.get("/setting/contact_us")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateContactUs(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/contact_us", data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

